import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100",
  viewBox: "0 0 66.8 45.2116"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "nonzero",
      d: "m63.385 0-.001.011L66.8.0116v2l-3.416-.0006v3.4l3.416.0006v2l-3.416-.0006v3.4l3.416.0006v2l-3.416-.0006v3.4l3.416.0006v2l-3.416-.0006v3.4l3.416.0006v2l-3.416-.0006v3.4l3.416.0006v2l-3.416-.0006v3.4l3.416.0006v2l-3.416-.0006v3.4l3.416.0006v2l-3.416-.0006v3.4l3.416.0006v2h-5.3v-.0126L5.4 45.2v.0116H0v-2l3.384-.0006v-3.4L0 39.8116v-2l3.384-.0006v-3.4L0 34.4116v-2l3.384-.0006v-3.4L0 29.0116v-2l3.384-.0006v-3.4L0 23.6116v-2l3.384-.0006v-3.4L0 18.2116v-2l3.384-.0006v-3.4L0 12.8116v-2l3.384-.0006v-3.4L0 7.4116v-2l3.384-.0006v-3.4L0 2.0116v-2L3.384.011 3.385 0h60ZM20.788 18.217 5.4 33.134v1.2776l-.016-.0006v3.4l.016.0006v2l-.016-.0006.001 3.389h43.954L20.788 18.217ZM61.385 2H37.516L22.229 16.82 52.377 43.2h9.008V2ZM34.642 2H5.4v.0116l-.016-.0006v3.4l.016.0006v2l-.016-.0006v3.4l.016.0006v2l-.016-.0006v3.4l.016.0006v2l-.016-.0006v3.4l.016.0006v2l-.016-.0006v3.4l.016.0006v2l-.016-.0006v1.352L34.642 2Z"
    }, null, -1)
  ])))
}
export default { render: render }